import type { Component } from 'vue';

const load = () => import('./ui/index.vue');

export const CallbackModal: Component = defineAsyncComponent(() =>
  load().then((m: { default: Component }) => m.default),
);

export const prefetchCallbackModal = (): void => {
  load().catch(() => null);
};
